import React, {useState, useEffect} from 'react'
import { useAcceptJs } from 'react-acceptjs';
import validator from 'validator'
import Cards from "react-credit-cards";
import axios from "axios";
import { payAPI } from '../../apis/urls';
import "react-credit-cards/es/styles-compiled.css";
import { $ } from 'react-jquery-plugin';
import { Link, useNavigate, useParams } from 'react-router-dom'


const authData = {
    // apiLoginID: '5WKar6q2wrK',
    // clientKey: '9V8VN7YZ3DJk752AvZX7ZBLTjrMwamFY4uU6b6zB5xqcgfa6CBw5mMXnb2zSFwJY',

    // live key
    // apiLoginID: '5L7AyX9by',
    // clientKey: '7CAw5C2feDuqK9XGrZv2DX6cTv4EPjtj22RbmmZF85b29DwFv5weT5mWTHK7Dw36',
    
    // test key
     apiLoginID: '893wG9Scn',
    clientKey: '649cbK67wtP6gdVM3Xx6RtS4xDY8943Cy8F4w3T64y7F2LEpwxdfAKq4kMRu6VVR',
  };

  const BasicCardInfo = {
    
    cardNumber: '',
    month: '',
    year: '',
    cardCode: '',
  };


  let coachId = localStorage.getItem('coachid')

  console.log(coachId);
  
 

  


const PayFormUI = () => {

    const { rid, oid } = useParams();  
    let amount = localStorage.getItem('ruleamount')
    let total = parseFloat((amount) * 103.5 / 100).toFixed(2);
    let coachId = localStorage.getItem('coachid')

    



    let navigate = useNavigate();
    const { dispatchData, loading, error } = useAcceptJs({ authData});
    //const { dispatchData, loading, error } = useAcceptJs({ authData , environment: 'PRODUCTION'});

    const [cardData, setCardData] = useState({
        cardName: '',
        cardNumber: '' ,
        cardCode: '',
        month: '',
        year: '',
        // focus: '',
    });

    const [errorMessage, setErrorMessage] = useState('');
    const [paystate, setPayState] = useState(false);
    const [errstate, setErrState] = useState(false);
    const [showw, setShoww] = useState(true);
    const [montherrorMessage, setMonthErrorMessage] = useState('');
    const [numError, setNumError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [monthError, setMonthError] = useState(false);
    const [yearError, setYearError] = useState(false);
    const [codeError, setCodeError] = useState(false);
    const [dataValue, setDatavalue] = useState('');

    const now = new Date();
    const until = new Date(now.getFullYear() + 10, now.getMonth());

    useEffect(() => {

        $('body').removeClass('').addClass('sidebar-collapsed');
        $('.sidebar-toggler').removeClass('sidebar-toggler').addClass('pay-toggler');

        

    },[]);

    const dashbord = () =>{
        navigate("/select_rule");
    }

    const dashbords = () =>{
        navigate("/questions/"+rid);
    }


    const handleSubmit = async (event) => {
        
        let error = 0;

		if(numError === '')
		{
			setNumError(true)
			error =1;
		}
		else
		{
			setNumError(false)
		}

        if(cardData.cardNumber  === '')
		{
			setNumError(true)
			error =1;
		}
		else
		{
			setNumError(false)
		}

        if(cardData.cardName === '')
		{
			setNameError(true)
			error =1;
		}
		else
		{
			setNameError(false)
		}


        if(cardData.month === '')
		{
			setMonthError(true)
			error =1;
		}
		else
		{
			setMonthError(false)
		}
        if(cardData.year  === '')
		{
			setYearError(true)
			error =1;
		}
		else
		{
			setYearError(false)
		}
        if(cardData.cardCode  === '')
		{
			setCodeError(true)
			error =1;
		}
		else
		{
			setCodeError(false)
		}

        if (cardData.cardNumber !== '' && 
            numError === false && 
            cardData.cardCode !== '' 
            && codeError === false && 
            cardData.month !== '' && 
            monthError === false &&
            cardData.cardName !== '' && 
            nameError === false &&
             
            cardData.year !== '' && 
            yearError === false
            ) {
            
            // alert("Valid")

            event.preventDefault();
        
            // Dispatch CC data to Authorize.net and receive payment nonce for use on your server
            const response = await dispatchData({ cardData });

            console.log("dispatched Datass", response );
        

            let Authtoken = "Bearer "+localStorage.getItem('token');

            console.log("authtoken is",Authtoken);
        
            const instance = axios.create({

                baseURL: payAPI  ,

                timeout: 1000000,

                headers: {'authorization': Authtoken}

            });

            const datass = {

                coach_id:coachId,
                
                rule_id:rid,

                amount:amount,

                token: response.opaqueData.dataValue,
            }

            instance.post('', datass,).then((response) =>{
                
                // setSchresult(response.data.data.items);

                console.log('payment test response',response);

                if (response.data.message === 'Success') {

                    setPayState(true);

                    setShoww(false);
                    
                    console.log('payment response',response);

                } else {

                    setErrState(true)

                    setShoww(false);

                }


            
            }).catch((error) =>{
                
                console.log('error',error.message)
                

            });
        
            console.log('Received cardData:', cardData.cardNumber);
        
            if (response.resultCode){
                

            }
            console.log('Received response:', response.messages);

            }
        
        };

        const handleFocus = (e) => {
            setCardData({ 
                ...cardData,
                focus: (e.target.name === 'cardCode') ? 'cvc' : e.target.name
            });
        }

      
    
    const validateCreditCard = (event) => {
        
        if (validator.isCreditCard(event.target.value))  {
        setErrorMessage('')
        setNumError(false);
        // setCardData({ ...cardData, cardNumber: event.target.value })
        } else {
        setErrorMessage('Enter valid CreditCard Number!')
        setNumError(true);
        }  
        
    }

    const validateName = (event) => {
        
        if (event.target.value !== '')  {

            setNameError(false);
            } else {
            setNameError(true);
            }  
        
    }

    const validateMonth = (event) => {
        
        if (event.target.value !== '')  {

            setMonthError(false);
            } else {
            setMonthError(true);
            }  
        
    }

    const validateYear = (event) => {
        
        if (event.target.value !== '')  {

            setYearError(false);
            } else {
            setYearError(true);
            }  
        
    }

    const validateCode = (event) => {
        
        if (event.target.value !== '')  {

            setCodeError(false);
            } else {
            setCodeError(true);
            }  
        
    }

  return (

    <div>

        <aside class="right-side areas">
                
            <div class="content-area dash-contentss no-header">
                
                <div class="page-title-wrpr">
                    
                    <div class="page-title-left-column">
                        
                        <h2 class="page-title">Payment</h2>
                        
                    </div>

                </div>

                <div className="mb-5"></div>

                {

                    showw ?

                        <form className="needs-validation" onSubmit={handleSubmit}>

                            <div className="form-wrpr qform">

                                <div className="card formcard qform small">
                                <p style={{textAlign:'center', paddingTop:'25px', fontSize:'14px'}}>Including credit card processing fee, the amount is <span style={{fontWeight:900}}>${total}</span></p>
                                                        
                                    <div className="card-body">

                                    <Cards
                                        cvc={cardData.cardCode}
                                        expiry={cardData.month}
                                        focused={cardData.focus}
                                        name={cardData.cardName}
                                        number={cardData.cardNumber}
                                    />

                                            <div className="mb-5"></div>

                                            <div className="form-group">
                                                
                                                <div className="row">
                
                                                    <div className="col-md-12">
            
                                                    <label style={{}} >Card Holder's Name <span style={{color: "red"}}>*</span></label>
            
                                                        <input
                                                            type="text"
                                                            name="cname"
                                                            style={{textTransform: 'uppercase'}}
                                                            className="form-control  justshow bg-dark" 
                                                            value={cardData.cardName}
                                                            onFocus={handleFocus}
                                                            onChange={(event) => {
                                                                validateName(event)
                                                                setCardData({
                                                                    
                                                                    ...cardData, cardName: event.target.value 
                                                                
                                                                })
                                                            }
                                                            }
                                                        />
            
                                                        {
                                                            nameError? 
            
                                                                <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                                    Please enter Name
                                                                </div>
                                                                
                                                            :
                                                                
                                                                null
                                                        }
            
            
                                                    </div> 
            
                                                    {/* <div className="col-md-4">
            
                                                    <label >Year:<span style={{color: "red"}}>*</span></label> */}
            
                                                        {/* <input
                                                            type="text"
                                                            id='exYear'
                                                            maxLength={4}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }} */}
                                                    
                                                            {/* // name="year"
                                                            // className="form-control  justshow bg-dark" 
                                                            // value={cardData.year}
                                                            // onChange={(event) =>{ */}
                                                            {/* //     validateYear(event)
                                                            //     setCardData({ ...cardData, year: event.target.value })
                                                            //     }
                                                            // } */}
                                                        {/* /> */}
            
                                                    {/* {
                                                        yearError? 
            
                                                            <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                                Please enter Year
                                                            </div>
                                                            
                                                        :
                                                            
                                                            null
                                                    } */}
            
                                                        
                                                    {/* </div> */}
            
                                                    
            
                                                </div>
            
                                            </div>

                                        <div className="form-group">
                                                
                                            <div className="row">
            
                                                <div className="col-md-12">

                                                <label >Card Number: <span style={{color: "red"}}>*</span></label>

                                                    <input
                                                        type="text"
                                                        name="cardNumber"
                                                        maxLength={16}
                                                        pattern="[\d| ]{16,22}"
                                                        onFocus={handleFocus}
                                                        className="form-control  justshow bg-dark" 
                                                        value={cardData.cardNumber}
                                                        onChange={(event) => {
                                                            validateCreditCard(event)
                                                            setCardData({ ...cardData, cardNumber: event.target.value })

                                                        }  

                                                        }
                                                    />

                                                {
                                                    numError? 

                                                        <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                            Please enter Card Nmber
                                                        </div>
                                                        
                                                    :
                                                        
                                                        null
                                                }

                                                    <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                        {errorMessage}
                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div className="mb-2"></div>

                                        <div className="form-group">
                                                
                                            <div className="row">
            
                                                <div className="col-md-6">

                                                <label style={{}} >Month <span style={{color: "red"}}>*</span></label>

                                                    <input
                                                        type="text"
                                                        id="exMonth"
                                                        // onInput="value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                        maxLength={2}
                                                        onFocus={handleFocus}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                        name="cdate"
                                                        placeholder='MM'
                                                        className="form-control  justshow bg-dark" 
                                                        value={cardData.month}
                                                        onChange={(event) => {
                                                            validateMonth(event)
                                                            setCardData({
                                                                
                                                                ...cardData, month: event.target.value 
                                                            
                                                            })
                                                        }
                                                        }
                                                    />

                                                    {
                                                        monthError? 

                                                            <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                                Please enter month
                                                            </div>
                                                            
                                                        :
                                                            
                                                            null
                                                    }


                                                </div> 
                                                

                                                 <div className="col-md-6">

                                                <label >Year:<span style={{color: "red"}}>*</span></label> 

                                                     <input
                                                        type="text"
                                                        id='exYear'
                                                        maxLength={4}
                                                        placeholder="YYYY"
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} 
                                                
                                                        name="year"
                                                        className="form-control  justshow bg-dark" 
                                                        value={cardData.year}
                                                        onChange={(event) =>{ 
                                                            validateYear(event)
                                                            setCardData({ ...cardData, year: event.target.value })
                                                            }
                                                        } 
                                                     /> 

                                                 {
                                                    yearError? 

                                                        <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                            Please enter Year
                                                        </div>
                                                        
                                                    :
                                                        
                                                        null
                                                } 

                                                    
                                                </div>

                                                </div>

                                                </div>



                                                <div className="mb-2"></div>

                                                <div className="form-group">
                                                
                                                <div className="row">

                                                <div className="col-md-6">

                                                    <label >CVC Number:<span style={{color: "red"}}>*</span></label>

                                                    <input
                                                        type="text"
                                                        placeholder='***'
                                                        maxLength={3}
                                                        name="cardCode"
                                                        onFocus={handleFocus}
                                                        className="form-control  justshow bg-dark"
                                                        value={cardData.cardCode}
                                                        onChange={(event) =>{
                                                            validateCode(event)
                                                            setCardData({ ...cardData, cardCode: event.target.value })
                                                        }
                                                        }
                                                    />

                                                {
                                                    codeError? 

                                                        <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>
                                                            Please enter Code
                                                        </div>
                                                        
                                                    :
                                                        
                                                        null
                                                }

                                                </div>

                                            </div>

                                        </div>

                                        <div className="form-group">
                                                
                                            <div className="row">
            
                                                <div className="col-md-12">

                                                    <button class="btn btn-primary btn-q" type="submit" disabled={loading || error}>

                                                        <b>Pay</b>

                                                    </button>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>    
                                
                        </form>

                    : 

                        null

                }

                {

                    paystate ?

                        <div className="form-wrpr qform">

                            <div className="card formcard qform small">
                                                        
                                <div className="card-body">

                                    <div className='row'>

                                        <div className='col-md-12'>

                                            <h4 style={{textAlign: 'center'}}>Payment Success</h4>

                                        </div>

                                    </div>

                                    <div className="form-group">
                                                
                                            <div className="row">
            
                                                <div className="col-md-6">

                                                    <button onClick={dashbord} class="btn btn-success btn-q" type="submit">

                                                        <b>Back to Home</b>

                                                    </button>

                                                </div>

                                                <div className="col-md-6">

                                                    <button onClick={dashbords} class="btn btn-success btn-q" type="submit">

                                                        <b>Go to Test</b>

                                                    </button>

                                                </div>

                                            </div>

                                        </div>

                                </div>

                            </div>

                        </div>


                    : 

                        null

                }

                {
                    errstate ?

                        <div className="form-wrpr qform">

                            <div className="card formcard qform small">
                                                        
                                <div className="card-body">

                                    <div className='row'>

                                        <div className='col-md-12'>

                                            <h4 style={{textAlign: 'center'}}>Payment Failed</h4>

                                        </div>

                                    </div>

                                    <div className="form-group">
                                                
                                            <div className="row">
            
                                                <div className="col-md-12">

                                                    <button onClick={dashbord} class="btn btn-danger btn-q" type="submit">

                                                        <b>Back to Home</b>

                                                    </button>

                                                </div>

                                            </div>

                                        </div>

                                </div>

                            </div>

                        </div>

                : 

                    null

                }

            </div>

        </aside>

    </div>

  )
}

export default PayFormUI